import React from "react";
import { createRoot } from "react-dom/client";
import { FestivalHome } from "../app/festival-home";
import { ReservationPage } from "../app/reservation-page";
import { AdminApp } from "../app/admin/admin-app";
import { StaffApp } from "../app/staff/[token]/staff-app";
import { TicketView } from "../app/ticket/[token]/ticket-view";
import "../app/globals.css";

function Router() {
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/admin") return <AdminApp />;
  if (path === "/reserve") return <ReservationPage />;

  const staff = path.match(/^\/staff\/([^/]+)$/);
  if (staff) return <StaffApp token={decodeURIComponent(staff[1])} />;

  const ticket = path.match(/^\/ticket\/([^/]+)$/);
  if (ticket) return <TicketView token={decodeURIComponent(ticket[1])} />;

  return <FestivalHome />;
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode><Router /></React.StrictMode>,
);
